import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Wallet, Building2 } from 'lucide-react';
import { RiyalIcon } from '@/lib/currency';

export default function CashBankWidget({ stats }) {
  const s = stats || {};
  return (
    <div>
      <h2 className="text-lg sm:text-2xl font-bold font-outfit mb-4">Cash & Bank In Hand</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="stat-card border-border border-cash/30 bg-gradient-to-br from-cash/5 to-cash/10" data-testid="cash-in-hand-card">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Cash In Hand</CardTitle>
            <div className="bg-cash/20 p-2 rounded-lg"><Wallet className="h-5 w-5 text-cash" strokeWidth={2} /></div>
          </CardHeader>
          <CardContent>
            <div className={`text-3xl font-bold font-outfit inline-flex items-center gap-1 ${(s.cash_in_hand || 0) >= 0 ? 'text-cash' : 'text-error'}`} data-testid="cash-in-hand-value"><RiyalIcon size="0.7em" /> {(s.cash_in_hand || 0).toFixed(2)}</div>
            <div className="mt-2 pt-2 border-t border-border flex flex-wrap gap-x-3 gap-y-1">
              <span className="text-[10px] text-success font-medium">Sales: <RiyalIcon size="0.85em" /> {(s.cash_sales || 0).toLocaleString()}</span>
              <span className="text-[10px] text-error font-medium">Exp: -{(s.expenses_cash || 0).toLocaleString()}</span>
              <span className="text-[10px] text-error font-medium">Supplier: -{(s.sp_cash || 0).toLocaleString()}</span>
            </div>
          </CardContent>
        </Card>
        <Card className="stat-card border-border border-bank/30 bg-gradient-to-br from-bank/5 to-bank/10" data-testid="bank-in-hand-card">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Bank In Hand</CardTitle>
            <div className="bg-bank/20 p-2 rounded-lg"><Building2 className="h-5 w-5 text-bank" strokeWidth={2} /></div>
          </CardHeader>
          <CardContent>
            <div className={`text-3xl font-bold font-outfit inline-flex items-center gap-1 ${(s.bank_in_hand || 0) >= 0 ? 'text-bank' : 'text-error'}`} data-testid="bank-in-hand-value"><RiyalIcon size="0.7em" /> {(s.bank_in_hand || 0).toFixed(2)}</div>
            <div className="mt-2 pt-2 border-t border-border flex flex-wrap gap-x-3 gap-y-1">
              <span className="text-[10px] text-info font-medium">Sales: <RiyalIcon size="0.85em" /> {(s.bank_sales || 0).toLocaleString()}</span>
              <span className="text-[10px] text-error font-medium">Exp: -{(s.expenses_bank || 0).toLocaleString()}</span>
              {(s.platform_received || 0) > 0 && <span className="text-[10px] text-success font-medium">Platform: +{(s.platform_received || 0).toLocaleString()}</span>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
